export interface VideoData {
  id: number
  name: string
  videoUrl: string
  thumbnailUrl: string
  heatmapUrl: string
  stoppingPower: number // SPR Score (0-100)
  views: number // Audience Signals
  engagementRate: number // SPR percentage
  engagementPoints: number
  category: 'ugc' | 'agency'
  type: string
  standardError: number
  sampleSize: number
}

// Lagardère "Click & Collect — 10% off" creative test.
// Four background treatments of the same key visual were tested as static images.
export const mockVideoData: VideoData[] = [
  {
    id: 1,
    name: 'Red Background',
    videoUrl:
      'https://cdn.magicpatterns.com/uploads/75jBumGKP3mPhJbKgXntmF/Click__Collect_10_off_lagardere_-_red_background.png',
    thumbnailUrl:
      'https://cdn.magicpatterns.com/uploads/75jBumGKP3mPhJbKgXntmF/Click__Collect_10_off_lagardere_-_red_background.png',
    heatmapUrl:
      'https://cdn.magicpatterns.com/uploads/bDSpdXdZydxfEor64g4QVM/heatmap_click-collect-10-off-lagardere-red-background-png.jpg',
    stoppingPower: 84,
    views: 8240,
    engagementRate: 0.47,
    engagementPoints: 40,
    category: 'ugc',
    type: 'image',
    standardError: 0.05,
    sampleSize: 8240,
  },
  {
    id: 2,
    name: 'Yellow Background, Black Text',
    videoUrl:
      'https://cdn.magicpatterns.com/uploads/wJ3XjvZZ687UjzwmjpvJ13/Click__Collect_10_off_lagardere_-_yellow_background,_black_text.png',
    thumbnailUrl:
      'https://cdn.magicpatterns.com/uploads/wJ3XjvZZ687UjzwmjpvJ13/Click__Collect_10_off_lagardere_-_yellow_background,_black_text.png',
    heatmapUrl:
      'https://cdn.magicpatterns.com/uploads/uPPpPLtPv4zjXUQa2KKcWk/heatmap_click-collect-10-off-lagardere-yellow-background-black-text-png.jpg',
    stoppingPower: 78,
    views: 8115,
    engagementRate: 0.31,
    engagementPoints: 22,
    category: 'ugc',
    type: 'image',
    standardError: 0.04,
    sampleSize: 8115,
  },
  {
    id: 3,
    name: 'White Background, Red Text',
    videoUrl:
      'https://cdn.magicpatterns.com/uploads/mogkY4KmiWAcQMkty3nSpV/Click__Collect_10_off_lagardere.png',
    thumbnailUrl:
      'https://cdn.magicpatterns.com/uploads/mogkY4KmiWAcQMkty3nSpV/Click__Collect_10_off_lagardere.png',
    heatmapUrl:
      'https://cdn.magicpatterns.com/uploads/kBfb3GYk4jXYkHaLyXkgaQ/heatmap_click-collect-10-off-lagardere-png.jpg',
    stoppingPower: 56,
    views: 7420,
    engagementRate: 0.25,
    engagementPoints: 17,
    category: 'ugc',
    type: 'image',
    standardError: 0.03,
    sampleSize: 7420,
  },
  {
    id: 4,
    name: 'Black Background & Gold',
    videoUrl:
      'https://cdn.magicpatterns.com/uploads/w9iqmnJi1Xiz1KNN7TjPy1/Click__Collect_10_off_lagardere_-_black_background__gold.png',
    thumbnailUrl:
      'https://cdn.magicpatterns.com/uploads/w9iqmnJi1Xiz1KNN7TjPy1/Click__Collect_10_off_lagardere_-_black_background__gold.png',
    heatmapUrl:
      'https://cdn.magicpatterns.com/uploads/c9n7mwrS8dk9KFtDJe81ib/heatmap_click-collect-10-off-lagardere-black-background-gold-png.jpg',
    stoppingPower: 42,
    views: 7225,
    engagementRate: 0.38,
    engagementPoints: 28,
    category: 'ugc',
    type: 'image',
    standardError: 0.04,
    sampleSize: 7225,
  },
]

// Keep the old export name for backwards compatibility during migration
export const mockImageData = mockVideoData
export type ImageData = VideoData
